import { useState } from 'react';

import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { committeeDecisions } from 'utils';

const DecisionLink = ({ path, children }) => (
  <Link
    className="modalBtnStyle ant-btn"
    to={path}
  >
    {children}
  </Link>
);

const decisionItems = (offerId, commiteeID, step, isForeignProcess) => {
  const decisions = [
    {
      id: committeeDecisions.approved,
      label: <FormattedMessage id="article.actionBtn.decisionAccept" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.approved}`,
    },
    {
      id: committeeDecisions.opinion,
      label: <FormattedMessage id="article.actionBtn.decisionAskOpinion" />,
      path: `/heyet-karar/${step}/${offerId}/${commiteeID}/${committeeDecisions.opinion}`,
    },
    {
      id: committeeDecisions.sendSupervisor,
      label: <FormattedMessage id="article.actionBtn.decisionSendSupervisor" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.sendSupervisor}`,
    },
    {
      id: committeeDecisions.revert,
      label: <FormattedMessage id="article.actionBtn.decisionRevent" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.revert}`,
    },
    {
      id: committeeDecisions.rewrite,
      label: <FormattedMessage id="article.actionBtn.decisionRewrite" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.rewrite}`,
    },
    {
      id: committeeDecisions.rejected,
      label: <FormattedMessage id="article.actionBtn.decisionReject" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.rejected}`,
    },
  ];

  // Tercüme aşaması yalnız yabancı yazarlı maddelerde vardır; backend bu kararı diğer maddelerde
  // 400 ile reddettiği için buton koşullu basılıyor ve hata kullanıcıya hiç görünmüyor.
  if (isForeignProcess) {
    decisions.push({
      id: committeeDecisions.sendTranslation,
      label: <FormattedMessage id="article.actionBtn.decisionSendTranslation" />,
      path: `/heyet-karar/${step}/${offerId}/${committeeDecisions.sendTranslation}`,
    });
  }

  return decisions;
};
/**
 * IH Heyet Kararları
 *
 * @param {number} offerId Madde teklifi ID'si.
 * @param {number} commiteeID Maddenin sorumlu ilim heyeti ID'si.
 * @param {number} step Maddenin süreç adımı; karar route'unun ilk parametresi.
 * @param {boolean} [isForeignProcess=false] Madde yabancı yazar sürecinde mi. Yalnız `true` iken
 *   "Tercüme'ye Gönder" kararı listelenir. Bayrak dışarıdan geçilir, burada yeniden hesaplanmaz.
 */
const CommiteeDecisionActions = ({ offerId, commiteeID, step, isForeignProcess = false }) => {
  const decisions = decisionItems(offerId, commiteeID, step, isForeignProcess);

  const [showButton, setShowButton] = useState(false);

  return (
    <>
      {showButton && (
        <div className="modalBtnGrp">
          {decisions.map((decision) => (
            <DecisionLink
              key={decision.id}
              path={decision.path}
            >
              {decision.label}
            </DecisionLink>
          ))}
        </div>
      )}
      <Button
        className={showButton ? 'gx-my-4' : ''}
        type={showButton ? 'primary' : 'default'}
        onClick={() => setShowButton(!showButton)}
        block
      >
        {showButton ? 'Vazgeç' : 'Karar Ver'}
      </Button>
    </>
  );
};

export default CommiteeDecisionActions;
